export const setTokenHeader = (axiosConfig) => {
    let token = sessionStorage.getItem('assume_token') || localStorage.getItem('token');

    if (token) {
        axiosConfig.headers.Authorization = `Bearer ${token}`;
    }
};
